import { InjectionToken } from '@angular/core';
import { WebSocketLink } from 'apollo-link-ws';

export const SUBSCRIPTION_LINK = new InjectionToken<WebSocketLink>(
  'SUBSCRIPTION_LINK'
);
